// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 29631, offsets 507324:509423. Structure and names inferred from code, not screenshots.
import dependency61104 from "../recovered/asset.js";
let n = new Set(dependency61104);
function o(e) {
  return decodeURI(String(e ?? ""));
}
let a = "zh-CN",
  r = "en-US",
  l = "/docs",
  s = "/models",
  c = [l, "/test-docs"];
function d(e) {
  return "zh" === e ? a : r;
}
function u(e) {
  var t;
  let i = String(e ?? "").match(
    /\/(?:docs|test-docs|models)\/(zh-CN|en-US)(?:\/|$)/u,
  );
  return i ? ((t = i[1]) === a ? "zh" : t === r ? "en" : null) : null;
}
function p(e) {
  let t = String(e ?? "");
  for (let e of c)
    if (
      RegExp(`${e}/(?:zh-CN|en-US)(?:/|$)`, "u").test(t) ||
      RegExp(`${e}/[^/]`, "u").test(t) ||
      RegExp(`${e}/?$`, "u").test(t)
    )
      return e;
  return /\/models\/(?:zh-CN|en-US)(?:\/|$)/u.test(t) ||
    /\/models\/[^/]/u.test(t) ||
    /\/models\/?$/u.test(t)
    ? "/models"
    : null;
}
function m(e) {
  let t = String(e ?? "")
    .trim()
    .replace(/^\/+/u, "")
    .replace(/\/+$/u, "");
  return t.startsWith(`${a}/`)
    ? t.slice(a.length + 1)
    : t === a
      ? ""
      : t.startsWith(`${r}/`)
        ? t.slice(r.length + 1)
        : t === r
          ? ""
          : t;
}
function h(e) {
  let t = e.replace(/\/$/u, "") || e,
    i = (e) =>
      t === `${e}/${a}` ||
      t.startsWith(`${e}/${a}/`) ||
      t === `${e}/${r}` ||
      t.startsWith(`${e}/${r}/`);
  return c.some((e) => i(e)) || i(s);
}
function g(e, t) {
  let i = d(t),
    n = p(e) ?? l,
    o = m(e.slice(e.indexOf(n) + n.length)),
    a = o ? `/${o}` : "";
  return `${n}/${i}${a}`;
}
function f(e, t, i = l) {
  let n = String(t ?? "")
    .trim()
    .replace(/^\/+/u, "");
  return n ? `${i}/${e}/${n}` : `${i}/${e}`;
}
function M(e, t) {
  let i = (e || "/").replace(/\/+$/u, "") || "/",
    n = (e) =>
      i === `${e}/${a}` ||
      i.startsWith(`${e}/${a}/`) ||
      i === `${e}/${r}` ||
      i.startsWith(`${e}/${r}/`);
  for (let e of c)
    if (n(e)) {
      let t = i === `${e}/${a}` || i.startsWith(`${e}/${a}/`);
      return `${e}/${t ? a : r}`;
    }
  if (n(s)) {
    let e = i === `${s}/${a}` || i.startsWith(`${s}/${a}/`);
    return `${s}/${e ? a : r}`;
  }
  return `${l}/${d(t)}`;
}
function y(e, t, i) {
  let o = p(e),
    a = o ?? p(t);
  if (!a) return e;
  if (e === a) return M(t, i);
  let r = String(e.slice(a.length)).replace(/^\/+/u, "");
  if (a === l && r && n.has(r)) return `${l}/${r}`;
  let s = e.slice(a.length),
    c = M(t, i),
    u = o && !t.startsWith(o) ? `${o}/${d(i)}` : c;
  return s ? `${u}${s.startsWith("/") ? s : `/${s}`}` : u;
}
export {
  o as $C,
  y as BC,
  h as CT,
  u as EH,
  d as Oz,
  M as Qe,
  f as am,
  g as ee,
  m as ui,
  p as z9,
};
